<app-accordion [multiple]="true">
  <app-accordion-item id="productSpecifications" label="Especificações" icon="info">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
      @for (spec of specifications | keyvalue; track spec) {
      <div>
        <div>{{ spec.key }}</div>
        <div class="font-medium">{{ spec.value.join(', ') }}</div>
      </div>
      }
    </div>
  </app-accordion-item>
</app-accordion>
